import React from 'react';
import { Button } from 'components/common';
import { FaUserTie } from 'react-icons/fa';
import { MdOutlineMarkEmailRead } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
const RequestUserAccountConfirmationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="tw-bg-white tw-rounded-2xl tw-shadow-sm tw-border tw-border-slate-100 tw-p-10">
      <h5 className="tw-flex tw-items-center tw-gap-2 tw-text-base tw-font-bold tw-text-blue-600 tw-mb-3">
        <FaUserTie /> Request Submitted!
      </h5>
      <p className="tw-text-sm tw-text-slate-600 tw-mb-6">
        Your request for create a new user account has been submitted to the IT department successfully.
      </p>

      <div className="tw-flex tw-justify-center tw-mb-6">
        <MdOutlineMarkEmailRead className="tw-text-green-500" size={100} />
      </div>

      <div className="tw-flex tw-justify-center">
        <Button variant="primary" onClick={() => navigate(-1)}>Go Back</Button>
      </div>
    </div>
  );
};

export default RequestUserAccountConfirmationPage;
